import { Order } from '@/store/Orders/types';

export const getCustomerName = (order: Order) => {
  if (!order.firstName) return order.lastName;
  return `${order.firstName} ${order.lastName}`;
};
